import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

const languagesMapper = {
  ua: 'en',
  al: 'en',
}
const siteKey = process.env.REACT_APP_CAPTCHA_KEY || 'sitekey'

const Recaptcha = ({onChange, hl}) => {
  const lang = languagesMapper[hl] || hl

  return <ReCAPTCHA sitekey={siteKey} onChange={onChange} hl={lang} />
}

export default Recaptcha
